module.exports = __webpack_public_path__ + "img/bimbo.6adb7e3b.png";